export default __webpack_public_path__ + "assets/3.2c0829ef.png";